import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {
    IModelBase,
    IStatusMessage,
    ResponseStatus
} from '../../common/Interfaces';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { Table } from '../efaact-primeng.module';
import { IShowErrors } from './IShowErrors';

const log = new LoggingService();
@Component({
    template: '',
    standalone: false
})
export class DisplayErrors<T extends IModelBase> implements OnChanges {
    @Input() public items: T[];
    @Input() public selectedError: IStatusMessage;
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    @ViewChild('dataTable', { read: Table, static: true }) dataTable: Table;
    onStatusClick(item: { id: string | number }) {
        this.ShowError.emit({ open: true, MsgEntityID: item.id.toString() });
    }

    highlightRow(rowId: string, ...styles: string[]) {
        const row = document.getElementById(rowId);
        if (!row) {
            return;
        }
        log.verbose({
            type: `DisplayErrors<${typeof this}>:highlightRow`,
            classList: row.classList,
            row
        });
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add(...styles);
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.selectedError) {
            const value = changes.selectedError.currentValue;
            const oldValue = changes.selectedError.previousValue;
            log.verbose({
                type: `DisplayErrors<${typeof this}>:selectedError:set`,
                value,
                oldValue
            });
            if (!value) {
                return;
            }
            try {
                if (oldValue && oldValue.MsgEntityID) {
                    const oldRow = document.getElementById(
                        `row-${oldValue.MsgEntityID.toString()}`
                    );
                    if (oldRow) {
                        oldRow.classList.remove('highlight');
                        oldRow.classList.remove('p-highlight');
                        oldRow.classList.remove('highlight-warning');
                        oldRow.classList.remove('highlight-danger');
                    }
                }
                if (!(value && value.MsgEntityID)) {
                    return;
                }
                const styles: string[] = [];
                styles.push('p-highlight');
                styles.push('highlight');
                if (value.StatusCode === ResponseStatus.Warning) {
                    styles.push('highlight-warning');
                }
                if (value.StatusCode === ResponseStatus.Failed) {
                    styles.push('highlight-danger');
                }
                const rowId = `row-${value.MsgEntityID.toString()}`;
                const row = document.getElementById(rowId);
                log.verbose({
                    type: `DisplayErrors<${typeof this}>:selectedError`,
                    value,
                    row
                });
                if (this.dataTable && !this.dataTable.loading) {
                    if (!row) {
                        if (!this.items) {
                            return;
                        }
                        // virtual row?
                        const idx = this.items.findIndex(
                            item =>
                                item.id.toString() ===
                                value.MsgEntityID.toString()
                        );
                        this.dataTable.scrollToVirtualIndex(idx);
                        setTimeout(() => {
                            this.highlightRow(rowId, ...styles);
                        }, 0);
                        return;
                    } else {
                        const idx = this.items.findIndex(
                            item =>
                                item.id.toString() ===
                                value.MsgEntityID.toString()
                        );
                        this.dataTable.scrollTo({
                            top:
                                row && row.offsetHeight
                                    ? row.offsetHeight * idx
                                    : 0,
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'nearest'
                        });
                    }
                    this.highlightRow(rowId, ...styles);
                }
            } catch (e) {
                log.error(e);
            }
        }
    }
}
